// src/pages/HomePage.js
import React from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';

function HomePage() {
  return (
    <div className="landing-container">
      <div className="landing-content">
        <div className="hero-section">
          <h1 className="landing-title">
            <span className="gradient-text">JobFAX</span>
          </h1>
          <h2 className="landing-subtitle">
            Verify Job Postings Before You Apply
          </h2>
          <p className="landing-description">
            Protect yourself from job scams with our comprehensive URL safety checker. 
            Analyze job postings, verify company information, and make informed decisions 
            about your career opportunities.
          </p>
          
          <div className="landing-actions">
            <Link to="/register" className="primary-button">
              Get Started Free
            </Link>
            <Link to="/login" className="secondary-button">
              Sign In
            </Link>
          </div>
        </div>

        <div className="features-section">
          <h3>Why Choose JobFAX?</h3>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🛡️</div>
              <h4>URL Safety Analysis</h4>
              <p>Advanced algorithms detect suspicious job posting URLs and potential scams</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🏢</div>
              <h4>Company Verification</h4>
              <p>Verify if the job posting matches the claimed company's official presence</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">📄</div>
              <h4>Job Description Analysis</h4>
              <p>Analyze job description quality and detect red flags in posting content</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h4>Search History</h4>
              <p>Track your verification history and build a database of trusted sources</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h4>Real-time Analysis</h4>
              <p>Get instant results with detailed safety reports and risk assessments</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🔗</div>
              <h4>URL Expansion</h4>
              <p>Automatically expand shortened URLs to reveal true destinations</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage;